import { render } from "./CustomTextarea.vue?vue&type=template&id=3180d682&scoped=true"
import script from "./CustomTextarea.vue?vue&type=script&lang=js"
export * from "./CustomTextarea.vue?vue&type=script&lang=js"

import "./CustomTextarea.vue?vue&type=style&index=0&id=3180d682&lang=scss&scoped=true"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3180d682"]])

export default __exports__